import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

type PasswordProps = Omit<React.ComponentProps<typeof Input>, "type"> & {
  showPasswordLabel?: string;
  hidePasswordLabel?: string;
};

export function Password({
  className,
  hidePasswordLabel = "Hide password",
  showPasswordLabel = "Show password",
  ...props
}: Readonly<PasswordProps>) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <Input
        className={cn("pr-12", className)}
        type={showPassword ? "text" : "password"}
        {...props}
      />

      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute inset-y-1/2 right-0 h-fit -translate-y-1/2 cursor-pointer p-3"
        aria-label={showPassword ? hidePasswordLabel : showPasswordLabel}
      >
        {showPassword ? (
          <Eye className="size-5" />
        ) : (
          <EyeOff className="size-5" />
        )}
      </button>
    </div>
  );
}
